import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

interface KinerjaHarianLogsHeaderProps {
  onCreate: () => void
}

export function KinerjaHarianLogsHeader({
  onCreate,
}: KinerjaHarianLogsHeaderProps) {
  return (
    <div className="w-full p-6 border-b border-gray-30">
      <div className="flex items-center justify-between gap-6">
        <div className="space-y-1">
          <Text variant="heading-md" as="h2">
            Daftar Kinerja Harian Anda
          </Text>
          <Text variant="body" className="text-gray-90">
            Catatan otomatis dikirim ke E-Kinerja 3 hari setelah tanggal kinerja
            yang dicatat.
            <br />
            Setelah dikirim, catatan tidak dapat diubah lagi.
          </Text>
        </div>

        <Button className="shrink-0" onClick={onCreate}>
          <span className="flex items-center gap-2">
            <Icon color="inherit">add</Icon>
            <span>Catat Kinerja</span>
          </span>
        </Button>
      </div>
    </div>
  )
}
